<template>
  <div>
    <gat-grid
      title="Voyage"
      class="elevation-0"
      :items="voyageItems"
      :columns="columns"
      :fixedheader="true"
      height="calc(100vh - 135px)"
      reloadBtn
      :orgSortBy="orgSortColumns"
      @reload-clicked="retrieveVoyageItems(callId)"
      @row-clicked="editVoyage"
      :loading="isLoading">
      <template v-if="props.column.field == `TYPE`" slot="cell" slot-scope="props">
        {{ lookupCode(props.value, $store.state.constants.voyageTypes) }}
      </template>
      <template slot="btns">
        <wm-button-group class="right mr-2" :buttons="gridButtons" @addClick="addVoyage" />
      </template>
    </gat-grid>
  </div>
</template>

<script>
export default {
  name: 'VoygeList',
  props: {
    callId: [Number, String],
  },
  components: {},
  data() {
    return {
      orgSortColumns: [{ header: 'Date' }, { header: 'Time' }, { header: 'Type', desc: true }],
      isLoading: false,
    };
  },

  activated() {
    if (this.$store.state.portcall.voyage && this.$store.state.portcall.voyage.length === 0) {
      this.retrieveVoyageItems(this.callId);
    }
  },

  created() {},

  watch: {},

  computed: {
    canAddVoyage() {
      return this.$store.getters.userRight('RO.NEW_AND_EDIT');
    },

    columns() {
      const result = [];
      result.push({ header: 'Port', field: 'HarbourName' });
      result.push({ header: 'Type', field: 'TYPE' });
      result.push({ header: 'Date', field: 'LEFT_DATE', dataType: 'date' });
      result.push({ header: 'Time', field: 'LEFT_TIME', dataType: 'time' });
      result.push({ header: 'ISPS', field: 'SEQURITY_LEVEL' });
      return result;
    },

    voyageItems() {
      return this.$store.state.portcall.voyage;
    },

    gridButtons() {
      return [{ btnType: 'ADD', eventName: 'addClick', mainAction: true, disabled: !this.canAddVoyage }];
    },
  },

  methods: {
    retrieveVoyageItems(callId) {
      this.isLoading = true;
      this.$store
        .dispatch('getVoyage', callId)
        .then(() => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
    editVoyage(row) {
      this.$router.push(`/call/${this.callId}/voyage-item/${row.ID}`);
    },
    addVoyage() {
      this.$router.push(`/call/${this.callId}/new-voyage-item/`);
    },
  },
};
</script>

<style scoped></style>
